import type { SelectOption } from "@/types/SelectOption.ts";

export const leadStatusOptions: SelectOption[] = [
    { id: "", label: "" },
    { id: "Potential Client", label: "Potential Client" },
    { id: "Contract Signed", label: "Contract Signed" },
    { id: "Intake Complete", label: "Intake Complete" },
];

export const leadStatusOptionsWithNone = [
    { id: "none", label: "None" },
    ...leadStatusOptions.filter((option) => option.id !== ""),
];
